import { getFdaDisplayName } from "@capone/common";

export const getHtsErrorHeaderDisruption = (
  isFreeFdaEnabled: boolean,
  productVariant?: string
) =>
  `We were not able to load ${getFdaDisplayName({ isFreeFdaEnabled, productVariant })} at the moment.`;
export const HtsErrorHeaderCfar =
  "We were not able to load Cancel for any reason at the moment.";
export const HtsErrorMessage = "Try again to reload the options or continue.";
